// Please put date in YYYY-MM-DD format
export const merchPhotos = [
    {
        name: "StuySquad 2019 Shirt Front",
        desc: "The front of Flow B's shirt, designed by Jasmine Xiao.",
        date: "2019-01-27",
    	imgname: "stuysquad_2019-front.png",
    	credits: "Jasmine",
    },
    {
        name: "StuySquad 2019 Shirt Back",
        desc: "The back of Flow B's shirt, designed by Jasmine Xiao.",
        date: "2019-01-27",
    	imgname: "stuysquad_2019-back.png",
    	credits: "Jasmine",
    },
    {
        name: "StuFlow Hoodie",
        desc: "Model: Maggie Xu",
        date: "2020-06-01",
    	imgname: "stuyflow-hoodie-0.png",
    	credits: "Maggie",
    },
]
